// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"73bc82fb","88":"9d08120f","144":"87dc24a6","163":"44f6b236","311":"30cd3dec","363":"4d0b78f8","453":"9e5dc66c","487":"ab62fcb7","525":"f8d4d139","536":"1827a25f","558":"f980b50b","748":"c7ba7e4c","834":"f020fe1b","883":"dd5fa5e3","912":"ef80a80c","966":"521af012"}[chunkId] + ".chunk.js";
};